// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.documents[data-v-7d882ef3] {\n  margin-top: 35px;\n}\n", ""]);
// Exports
module.exports = exports;
